function modalHandler() {
  const modal = document.getElementById('myModal');

  const itemImages = document.getElementsByClassName('item-image');

  //Adds click listener to non-placeholder item images to render large image in modal
  for (let i = 0; i < itemImages.length; i += 1) {
    const itemImage = itemImages[i];
    const modalImage = document.getElementById('modal-image');
    const caption = document.getElementById('caption');

    if (!itemImage.classList.contains('placeholder')) {
      itemImage.onclick = function(){
        modal.style.display = "block";
        modalImage.src = this.src;
        caption.innerHTML = this.alt;
      }
    }
  }

  const span = document.getElementsByClassName('close')[0];
  modal.onclick = function() { 
    modal.style.display = "none";
  }
}


module.exports = modalHandler;


// WEBPACK FOOTER //
// ./public/src/modalHandler.js